import { getBulkLockPaginationUpperLimit } from '@dispatch/shared/services';
import { BulkLockPaginationUpperLimitConfig } from '@dispatch/shared/types';
import { useQuery } from '../useQuery';
import { isEmpty } from 'lodash';

export const useGetBulkLockPaginationUpperLimit = (
  tenantId: string,
  enabled = true
) => {
  const { data, status, refetch } = useQuery<
    BulkLockPaginationUpperLimitConfig | undefined
  >(
    ['bulk-lock-pagination-upper-limit'],
    () => getBulkLockPaginationUpperLimit(tenantId),
    {
      enabled: enabled && !isEmpty(tenantId),
    }
  );

  return {
    feature: data,
    featureStatus: status,
    fetchFeature: refetch,
  };
};
